<template>
  <div class="loginBox">
    <div class="logincont">
      <span @click="loginIn">登录</span>
    </div>
  </div>
</template>

<script>
import Mgr from '../assets/js/SecurityService';
export default {
  methods: {
    loginIn() {
      let mgr = new Mgr();
      // mgr.popupLayer();
      mgr.signIn();
    }
  },
  beforeCreate() {
    let mgr = new Mgr();
    mgr.getSignedIn().then(
      (signIn) => {
        console.log('signedIn', signIn);
        // this.signedIn = signIn;
        if (signIn) {
          this.$router.push('/home');
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
};
</script>

<style lang="scss" scoped>
.loginBox {
  height: 100%;
  background: url(../assets/images/denglu.jpg) repeat center top;
  background-color:#021C3F ;
  padding-top: 1px;
  box-sizing: border-box;
  .logincont {
    position: relative;
    width: 558px;
    height: 404px;
    margin: 0 auto;
    margin-top: 185px;
    background: url(../assets/images/kuang.png) no-repeat center center;
    span {
      position: absolute;
      width: 161px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 10px;
      border: 2px solid #fff;
      font-size: 21px;
      color: #fff;
      bottom: 25px;
      left: 50%;
      margin-left: -90px;
      cursor: pointer;
      transition: all 0.8s;
      &:hover {
        border-color: #2295fe;
        color: #2295fe;
      }
    }
  }
}
</style>
